import { render, staticRenderFns } from "./AnswerSaveButton.vue?vue&type=template&id=316cd9ee&"
import script from "./AnswerSaveButton.vue?vue&type=script&lang=js&"
export * from "./AnswerSaveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports